import React from 'react';
import { Image as RImage, Box, BackgroundImage as RBackgroundImage } from 'rebass';
import styled, { css } from 'styled-components';
import dayjs from 'dayjs';
import delve from 'dlv';
import ReactGA from 'react-ga';

import { SPACE, FONT_SIZE, breakpoints } from 'Components/Theme';
import { Text } from 'Components/Base';
import { getConfig } from 'Util/Config';

import { bannerList } from './BannerList.js';
import BannerCTAFixedText from './BannerCTAFixedText';

const startDate = delve(getConfig().mockFreeBanner, 'startDate');
const { downloadAppMyScoreUrl = '#' } = getConfig();

const bgImageSet = (img1x, img2x) => css`
  background-image: -webkit-image-set(url(${img1x}) 1x, url(${img2x}) 2x);
  background-image: image-set(url(${img1x}) 1x, url(${img2x}) 2x);
`;

const getBannerByDate = (bannerList = [], date = startDate, unit = 'day') => {
  const mDate = dayjs(date);
  if (mDate.isValid() && Array.isArray(bannerList)) {
    const variant = dayjs().diff(mDate, unit) % bannerList.length;
    return { variant: variant, image: bannerList[variant] };
  }
  return null;
};
const onHandleClick = bgImgName => {
  try {
    ReactGA.event({
      category: 'CAMPAIGN_MF_2562-01',
      action: 'Overview Banner Click',
      label: bgImgName,
    });
  } catch (err) {
    console.log('ga error:', err);
  }
};

const Container = styled(({ href, ...restProps }) => {
  const { bgImage, departmentTitle } = restProps;
  const bgFileName = bgImage.wide['1x'].split('/').pop();
  const bgImgName = `Banner ${bgFileName.substr(bgFileName.indexOf('_') + 1, 2)}
  ${departmentTitle ? 'from ' + departmentTitle : ''}`;

  return (
    <RBackgroundImage
      as="a"
      target={href ? '_blank' : '_self'}
      href={href || '#'}
      onClick={() => onHandleClick(bgImgName || '')}
      {...restProps}
    />
  );
})`
  position: relative;
  display: block;
  ${({ bgImage }) => {
    return css`
      /* TODO: temporary turn off mobile */
       /* ${bgImageSet(bgImage.mobile['1x'], bgImage.mobile['2x'])}; */
        ${bgImageSet(bgImage.narrow['1x'], bgImage.narrow['2x'])}

     /* @media (min-width: ${breakpoints[1]}px) {
        ${bgImageSet(bgImage.narrow['1x'], bgImage.narrow['2x'])}
      } */

      @media (min-width: ${breakpoints[2]}px) {
        ${bgImageSet(bgImage.wide['1x'], bgImage.wide['2x'])}
      }
    `;
  }}
`;

const BannerCTAView = ({ departmentTitle, bannerData }) => {
  const { variant, image: bgImage } = bannerData;

  const MAX_LENGTH = 32;
  let trimmedDeptTitle = departmentTitle;
  if (
    departmentTitle !== null &&
    departmentTitle !== undefined &&
    departmentTitle.length > MAX_LENGTH
  ) {
    trimmedDeptTitle = `${departmentTitle.slice(0, MAX_LENGTH)}...`;
  }

  if (trimmedDeptTitle !== null && trimmedDeptTitle !== undefined) {
    trimmedDeptTitle = `"${trimmedDeptTitle}"`;
  }

  return (
    <Container
      // ratio={[1196 / 800, null, 360 / 722, 180 / 928]}
      ratio={[360 / 722, null, null, 180 / 928]}
      href={downloadAppMyScoreUrl}
      bannerList={bannerList}
      bgImage={bgImage}
      departmentTitle={departmentTitle}
    >
      <BannerCTAFixedText variant={variant}>{trimmedDeptTitle}</BannerCTAFixedText>
    </Container>
  );
};

const BannerCTA = ({ departmentTitle }) => {
  const bannerData = getBannerByDate(bannerList);
  return <BannerCTAView bannerData={bannerData} departmentTitle={departmentTitle} />;
};

export { BannerCTAView, BannerCTA };

export default BannerCTA;
